import React, { Component, createContext } from 'react'
import { withRouter } from 'next/router'
import { config, api, asyncFunctionDecorator } from 'helpers'

const DataContext = createContext({})
export const DataConsumer = DataContext.Consumer

class DataProvider extends Component {
    state = {
        homeDebates: {
            feed: []
        },
        profileDebates: {
            debates: [],
            participants: [],
            favorites: [],
            draftDebates: []
        },
        searches: {
            users: [],
            debates: []
        },
        isFilter: false
    }

    methods = {
        getHomeDebates: this.getHomeDebates.bind(this),
        getProfileDebates: this.getProfileDebates.bind(this),
        getSearches: this.getSearches.bind(this),
        deleteDebate: this.deleteDebate.bind(this),
        toggleFilter: this.toggleFilter.bind(this),
        checkHasProfileDebates: this.checkHasProfileDebates.bind(this),
        contactUs: this.contactUs.bind(this),
        report: this.report.bind(this)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.router.asPath !== this.props.router.asPath) {
            this.toggleFilter(false)
        }
    }

    async getHomeDebates(filters, load = false) {
        return await api.get(`${config.routePrefix.debates}/home-debates`, this.checkFilterData(filters))
            .then(res => {
                if (load) {
                    this.setState({
                        ...this.state,
                        homeDebates: {
                            ...this.state.homeDebates,
                            [filters.type]: [
                                ...this.state.homeDebates[filters.type],
                                ...res[filters.type]
                            ],
                        }
                    })
                } else {
                    this.setState({
                        ...this.state,
                        homeDebates: {
                            ...this.state.homeDebates,
                            ...res
                        }
                    })
                }
            })
    }

    async getProfileDebates(filters, load = false) {
        return await api.get(`${config.routePrefix.debates}/profile-debates`, this.checkFilterData(filters)).then(res => {
            if (load) {
                this.setState({
                    ...this.state,
                    profileDebates: {
                        ...this.state.profileDebates,
                        [filters.type]: [
                            ...this.state.profileDebates[filters.type],
                            ...res[filters.type]
                        ],
                    }
                })
            } else {
                this.setState({
                    ...this.state,
                    profileDebates: {
                        ...this.state.profileDebates,
                        ...res
                    }
                })
            }
        })
    }

    async getSearches(filters) {
        return await api.get(`search`, {
            s: this.props.router.query.s,
            ...this.checkFilterData(filters)
        }).then(res => {
            this.setState({
                ...this.state,
                searches: {
                    ...this.state.searches,
                    ...res
                },
                isFilter: true
            })
        })
    }

    async deleteDebate(id) {
        return await api.delete(`${config.routePrefix.debates}/${id}`).then(() => {
            this.setState({
                ...this.state,
                profileDebates: {
                    ...this.state.profileDebates,
                    draftDebates: [...this.state.profileDebates.draftDebates.filter(item => item.id != id)]
                }
            })
        })
    }

    checkFilterData = (filter) => {
        const newValues = {}

        Object.keys(filter).forEach((val) => {
            if (filter[val] != undefined) {
                newValues[val] = filter[val]
            }
        })
        return newValues;
    }

    toggleFilter(val) {
        this.setState({
            ...this.state,
            isFilter: val
        })
    }

    checkHasProfileDebates() {
        return this.state.profileDebates.debates.length === 0
            && this.state.profileDebates.participants.length === 0
            && this.state.profileDebates.favorites.length === 0
            && this.state.profileDebates.draftDebates.length === 0
            && !this.state.isFilter;
    }

    contactUs(data) {
        return asyncFunctionDecorator(() => api.post('contact-us', data))
    }

    report(data) {
        return asyncFunctionDecorator(() => api.post('report', data))
    }

    render() {
        return (
            <DataContext.Provider value={{ ...this.state, ...this.methods }}>
                {this.props.children}
            </DataContext.Provider>
        )
    }
}

export default withRouter(DataProvider)
